{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "id": "platform-base",
  "order": 1,
  "accent": "steel",
  "eyebrow": "SHARED FOUNDATION",
  "title": "Platform Base",
  "valueStatement": "The secure foundation that powers every aviOS experience.",
  "outcome": "Trusted by design.",
  "sharedBy": [
    "intelligence",
    "vault",
    "operate",
    "shop",
    "forge"
  ],
  "workflow": [
    "Identify",
    "Authorize",
    "Govern",
    "Record",
    "Audit"
  ],
  "intelligenceInContext": {
    "name": "Governs all AI",
    "headline": "Every AI interaction is scoped, attributed, and auditable.",
    "helpsWith": [
      "Role-scoped AI access",
      "Provenance on AI outputs",
      "Audit of AI interactions"
    ],
    "drawsOn": [
      "All modules"
    ],
    "humanAuthority": "Policies and access decisions remain with administrators.",
    "aiUsage": "Not metered."
  },
  "evidenceProduced": [
    "Audit history",
    "Access records",
    "Provenance trail"
  ],
  "regulatory": {
    "anchors": [
      "ac-120-78b"
    ],
    "included": [
      "Identity & authentication",
      "Integrity controls",
      "Audit trail",
      "Retention & export"
    ],
    "readinessServices": []
  },
  "dataGovernance": {
    "headline": "Your data, governed.",
    "points": [
      "Tenant isolation",
      "Customer-controlled sharing",
      "Retention policies",
      "Source-of-truth authority",
      "Export and portability"
    ]
  },
  "pricingId": "pb-included",
  "showExtensions": false
}